import { z } from "zod";

export const ApiV1CommonQueryParamsSchema = z.object({
  nextToken: z.string().optional(),
  include: z.array(z.string()).optional(),
  objectiveAuthorityIds: z.array(z.string()).optional(),
});

// Input should be stricter. We expect this exact shape for all input to API.
export const ApiV1TagSchema = z.object({
  key: z.string(),
  type: z.literal("string"),
  value: z.string(),
});

// Response might include nullable/optional tags since we're shipping them from GQL.
export const ApiV1TagSchemaResponse = z.object({
  key: z.string().optional().nullable(),
  type: z.string().optional().nullable(),
  value: z.string().optional().nullable(),
});

export const ApiV1FilterTagsSchema = z.object({
  include: z
    .array(
      z.object({
        key: z.string(),
        type: z.literal("string").optional(),
        value: z.string().optional(),
      }),
    )
    .optional(),
  or: z
    .array(
      z.object({
        include: z.array(
          z.object({
            key: z.string(),
            type: z.literal("string").optional(),
            value: z.string().optional(),
          }),
        ),
      }),
    )
    .optional(),
});
